export interface MockBook {
  id: string;
  email: string;
  story: string;
  plush: string;
  count: number;
  status: string;
  risk: 'low' | 'medium' | 'high' | 'manual';
  order: string;
  date: string;
}

export const MOCK_ROWS: MockBook[] = [
  { id: 'BK-2104', email: 'anna.weber@gmail.com', story: 'Schlafstern', plush: 'Bruno', count: 1, status: 'Needs Review', risk: 'low', order: '#1942', date: '06.05.2026' },
  { id: 'BK-2103', email: 'j.huber@gmx.de', story: 'Abenteuer', plush: 'Mimi, Pucki', count: 2, status: 'Needs Review', risk: 'manual', order: '#1941', date: '06.05.2026' },
  { id: 'BK-2102', email: 'k.schmidt@web.de', story: 'Geburtstag', plush: 'Plüschi', count: 1, status: 'Needs Review', risk: 'low', order: '#1940', date: '06.05.2026' },
  { id: 'BK-2101', email: 'tom@familiekoch.de', story: 'Schlafstern', plush: 'Hoppel', count: 1, status: 'Needs Review', risk: 'medium', order: '#1939', date: '05.05.2026' },
  { id: 'BK-2100', email: 'sara.lang@me.com', story: 'Schlafstern', plush: 'Bruno, Sterni, Lulu', count: 3, status: 'Revision Requested', risk: 'low', order: '#1937', date: '05.05.2026' },
  { id: 'BK-2099', email: 'f.becker@posteo.de', story: 'Geburtstag', plush: 'Knuddel', count: 1, status: 'Approved', risk: 'low', order: '#1936', date: '05.05.2026' },
  { id: 'BK-2098', email: 'hello@neumann.eu', story: 'Abenteuer', plush: 'Dino', count: 1, status: 'Sent to Print', risk: 'low', order: '#1934', date: '04.05.2026' },
  { id: 'BK-2097', email: 'lisa.m@gmail.com', story: 'Schlafstern', plush: 'Schaf', count: 1, status: 'Paid', risk: 'low', order: '#1933', date: '04.05.2026' },
];

export const TAB_COUNTS = [
  { l: 'Drafts', n: 12 },
  { l: 'Sample Ready', n: 8 },
  { l: 'Checkout Started', n: 3 },
  { l: 'Paid', n: 6, c: 'var(--a-blue)' },
  { l: 'Generating', n: 2 },
  { l: 'Needs Review', n: 4, c: 'var(--a-amber)' },
  { l: 'Correction Requested', n: 1, c: 'var(--a-red)' },
  { l: 'Approved', n: 5, c: 'var(--a-green)' },
  { l: 'Print Ready', n: 3 },
  { l: 'Sent to Print', n: 9 },
  { l: 'Completed', n: 47 },
  { l: 'Rejected', n: 1 },
];
